/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { WorkflowViewModel } from './WorkflowViewModel'; 

export function getWorkflowOptions(workflowId: string, onSuccess?: (result: WorkflowViewModel) => void) {
	return queryOptions({
		queryKey: ['workflow', workflowId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/workflows/queries/getworkflow/' + workflowId;
			const resp = await axios.get<WorkflowViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(workflowId)
	});
}